import { Suspense } from 'react';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import AssetBackground from '~/components/Canvas/AssetBackground';
import AssetPlane from '~/components/Canvas/AssetPlane';
import CanvasLights from '~/components/Canvas/CanvasLights';
import { CanvasOptions } from '~/constants/Canvas';
import useCreateNewCharacterStore from '~/store/useCreateNewCharacterStore';
import AssetViewerLoading from './AssetViewerLoading';
import Character from './Character/Character';

export default function ChatAvatarCanvas() {
  const { id, url } = useCreateNewCharacterStore((state) => ({
    id: state.common.id,
    url: state.common.url,
  }));

  return (
    <Canvas shadows>
      <PerspectiveCamera
        position={CanvasOptions.asset.cameraPosition}
        fov={CanvasOptions.asset.cameraFov}
        makeDefault
      />
      <CanvasLights />
      <AssetBackground />
      <AssetPlane />
      <OrbitControls minDistance={2} maxDistance={8} enablePan={false} />

      <Suspense fallback={<AssetViewerLoading />}>
        {id && url && <Character id={id} url={url} />}
      </Suspense>
    </Canvas>
  );
}
